import React, { useEffect, useState } from 'react'
import { Timeline } from "flowbite-react";
import { HiCheck, HiArrowNarrowRight  } from "react-icons/hi";
import { ArrowLeft } from '@mui/icons-material';
import { customTimeline, customTimelineActivePoint } from '../../CustomTheme';
import { useLocalStorage, useLocalStorageWithParsing } from '../Context/LocalStorageContext';

import {  HiCalendar } from "react-icons/hi";
import { ArrowRight } from '../../svg/Icons';

const stepsData = [
    "Generate MPK",
    "Register MPK",
    "Request IDT++"
]

const stepsDataMobile = [
    "Generate",
    "Register",
    "Request IDT++"
]

const renderInactiveStep = (name: string): JSX.Element => {
    return <Timeline.Item key={name}>
        <Timeline.Point />
        <Timeline.Content>
            <Timeline.Title className='step-inactive'>{name}</Timeline.Title>
        </Timeline.Content>
    </Timeline.Item>
}

const renderActiveStep = (name: string): JSX.Element => {
    return <Timeline.Item key={name}>
        <Timeline.Point icon={HiArrowNarrowRight}/>
        <Timeline.Content>
            <Timeline.Title className='step-active'>{name}</Timeline.Title>
        </Timeline.Content>
    </Timeline.Item>
}

const renderCompletedStep = (name: string): JSX.Element => {
    return <Timeline.Item key={name}>
        <Timeline.Point icon={HiCheck} theme={customTimelineActivePoint()}/>
        <Timeline.Content>
            <Timeline.Title className='step-completed'>{name}</Timeline.Title>
        </Timeline.Content>
    </Timeline.Item>
}

const Steps = () => {
    const [step, _] = useLocalStorageWithParsing<number>("steps", 0);
  return (<>
    <div className='hidden md:block w-[260px] min-w-[260px] stepsSticky pl-4'>
        <Timeline theme={customTimeline()}>
            {stepsData.map((value, index) => {
                if(step < index) {
                    return renderInactiveStep(value)
                } else if(step === index) {
                    return renderActiveStep(value)
                } else {
                    return renderCompletedStep(value);
                }
            })}

        </Timeline>   
        
    </div>

    <div className='md:hidden flex w-full justify-center gap-2'>
        {/*<Timeline horizontal theme={customTimeline()}>
            {stepsData.map((value, index) => {
                if(step < index) {
                    return renderInactiveStep(value)
                } else if(step === index) {
                    return renderActiveStep(value)
                } else {
                    return renderCompletedStep(value);
                }
            })}

        </Timeline>  */} 

       {stepsDataMobile.map((name, index) => {
            if(step > index) {
                // Green done step
                return (<div key={name} className='gap-2 flex items-center'>
                    {index > 0 && <span className='text-gray-200'>/</span>}
                    <div className='leading-tight text-sm font-medium text-green-600'>
                        {name}
                    </div>
                    
                </div>)
            } else if(step === index) {
                // Blue current step
                return (<div key={name} className='gap-2 flex items-center'>
                    {index > 0 && <span className='text-gray-200'>/</span>}
                    <div className='flex gap-1 items-center leading-tight text-sm font-bold text-primary-600'>
                        <div className='bg-primary-100 rounded-lg p-[3px]'>
                            <ArrowRight className='size-6 text-primary-600'/>
                        </div>
                        {name}
                    </div>
                    
                </div>)
            } else {
                // Grey todo step
                return (<div key={name} className='gap-2 flex items-center'>
                    {index > 0 && <span className='text-gray-200'>/</span>}
                    <div className='leading-tight text-sm font-medium text-gray-500'>
                        {name}
                    </div>
                </div>)
            }
       })}
    </div>
  </>)
}

export default Steps
